export default {
    public: {
        url: '/storage',
    },
};
